import React from "react";
import styled from "styled-components";
import { TEXT_FONTSIZE } from "../utilities/constants";
import { Trans } from "react-i18next";

interface ButtonProps {
  text: string;
  color: string;
  padding?: string;
  itemObject?: object;
  onClick?: any;
  min?: string;
  centerText?: boolean;
}

const Button: React.FC<ButtonProps> = (props: ButtonProps) => {
  return (

    <ButtonWrapper
      onClick={props.onClick}
      color={props.color}
      padding={props.padding}
      min={props.min}
      centerText={props.centerText}
    >
      <Trans>{props.text}</Trans>
    </ButtonWrapper>
  );
}

interface ButtonWrapperProps {
  padding?: string;
  min?: string;
  centerText?: boolean;
}

const ButtonWrapper = styled.span<ButtonWrapperProps>`
  font-size: ${TEXT_FONTSIZE};
  font-weight: 500;
  color: ${(props) => (props.color === "white" ? "#0494CA" : "#fff")};
  margin: 0px;
  min-width: ${(props) => props.min || "none"};
  outline: none !important;
  padding: ${(props) => props.padding || "10px 50px"};
  border-radius: 50px;
  display: inline-block;
  cursor: pointer;
  position: relative;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  cursor: pointer;
  background-image: ${(props) =>
    props.color === "blue"
      ? "linear-gradient(to bottom, #0194e9, #35c1d0)"
      : props.color === "red"
        ? "linear-gradient(to right, #c43d29, #e83e25)"
        : props.color === "darkBlue"
          ? "linear-gradient(to bottom, #005068, #005068)" 
          : "none"};

  border: ${(props) =>
    props.color === "white" ? "1px solid #0494CA" : "none"};
  :hover {
    color: ${(props) => (props.color === "white" ? "black" : "#fff")};
    box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.3);
  }
  text-align: ${(props) => (props.centerText ? "center" : "")};
  @media (max-width: 360px) {
    padding: 7px 25px;
    min-width: 112px;
  }

  @media (min-width: 1200px) and (max-width: 1400px) {
    padding: 9px 30px;
    min-width: 100px;
    font-size: 14px;
  }
`;

export default Button;